import React, {Component} from 'react'
import Inputs from '../../shared/FormComponents/Inputs'
import { Link } from 'react-router-dom';
import _ from 'lodash';
import './Registration.css'

export default class Registration extends Component {
    constructor(props) {
      super(props);
      this.state = {
        uppercase: false,
        lowercase: false,
        numberic: false,
        specialCharacter: false,
        data:{
            name: '',
            email: '',
            password: '',
            confPassword: '',
        },
        inputStates: {
            name: false,
            email: false,
            password: false,
            confPassword: false,
        }
      };
    }

    onDataChange = (key, value, valid) => {
      const state = _.extend({}, this.state);
      state.inputStates[key] = valid;
      state.data[key] = value;
      this.setState(state, () => this.validateForm());
      if( key === 'password' ){
          let incLower = this.lowercase(value)
          let incuppercase = this.uppercase(value)
          let incnumberic = this.numberic(value)
          let specialCharacter = this.specialCharacter(value);

          if (incLower) {
              this.setState({  uppercase : true });
          }else{
              this.setState({  uppercase : false });
          }
          if (incuppercase){
              this.setState({  lowercase : true });
          }else{
              this.setState({  lowercase : false });
          }
          if(incnumberic){
              this.setState({  numberic : true });
          }else{
              this.setState({  numberic : false });
          }
          if(specialCharacter){
              this.setState({  specialCharacter : true });
          }else{
              this.setState({  specialCharacter : false });
          }

      }
    };

    lowercase = (str) => {
        return str.match(/[a-z]/);
    }

    uppercase = (str) => {
        return str.match(/\w*[A-Z]\w*/);
    }

    numberic = (str) => {
        return str.match(/\d+/)
    }

    specialCharacter = (str) => {
        return str.match(/[$@#$!%*?&]/);
    }

    validateForm = () => {
        let validationStates = _.extend({}, this.state.inputStates);
        let key = Object.values(validationStates).indexOf(false) !== -1;
        let state = !key;

        const { password, confPassword } = this.state.data;
        const checkFields = password.trim() && confPassword.trim() ? true : false;

        this.setState({ formValid: state && checkFields });
    }

    registerUser = () => {
        let data = {
            object: {
                provider: 'ipg',
                role:"student",
                email: this.state.data.email,
                name: this.state.data.name,
                password: this.state.data.password
            }
        }

        this.props.createUser(data);
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    //createUser={this.props.createUser}

    render() {
        const passwordConfirm = this.state.data.password === this.state.data.confPassword ? true : false;
        return (
            <div className="login-content">
                <div className="login-content-layout">
                    <div className="card">
                        <div className='card-header'>
                            <div className="logo-bg-layout">
                                {/* <h5 className='card-title'>eToolkit</h5> */}
                                <div className='login-logo-box'></div>
                            </div>
                        </div>
                        { (!this.props.createdUserFetching && _.isEmpty(this.props.createdUserData) ) &&
                            <div className="card-body">
                                <h5>Please log in with your password to access The Planning Tools.</h5>
                                { this.props.createdUserError &&
                                    <p className='error-reg'>{this.props.createdUserError.message}</p>
                                }
                                <form>
                                    <div className="form-group icon-input">
                                        <i class="fas fa-user"></i>
                                        <Inputs
                                            type="name"
                                            className="form-control"
                                            value={this.state.data.name}
                                            required={ true }
                                            placeholder='Name'
                                            onChange={ (value, valid) => this.onDataChange('name', value, valid)} />
                                    </div>
                                    <div className="form-group icon-input">
                                        <i className="fas fa-envelope"></i>
                                        <Inputs
                                            type="email"
                                            onChangeCheckExist={this.props.verifyOnExist}
                                            //verifyState={this.props.verifyState}
                                            verifyResponse={this.props.verifyState.email}
                                            className="form-control"
                                            value={this.state.data.email}
                                            required={ true }
                                            placeholder='Email'
                                            onChange={ (value, valid) => this.onDataChange('email', value, valid)} />
                                    </div>
                                    <div className="form-group icon-input" style={{overflow: "visible"}}>
                                        <i className="fas fa-unlock-alt"></i>
                                        <Inputs
                                            type="password"
                                            className="form-control"
                                            value={this.state.data.password}
                                            requied={ true }
                                            placeholder='Password'
                                            errorMessage={'5555'}
                                            onChange={ (value, valid) => this.onDataChange('password', value, valid)} />
                                            <i className="fa fa-info infoIcon"></i>
                                            <div className="info">Password should includes a minimum of 1 lower case letter, minimum of 1 upper case letter, minimum of 1 numeric character and a minimum of 1 special character: {`~!@#$%^&*()-_+={}[]|\;:"<>,./?`}</div>
                                            <ul className="password-valid-card">
                                                <li className={ this.state.lowercase ? 'done' : '' } > <i class="fas fa-circle"></i> Minimum of one lowercase character</li>
                                                <li className={ this.state.uppercase ? 'done' : '' } > <i class="fas fa-circle"></i> Minimum of one uppercase character</li>

                                                <li className={ this.state.numberic ? 'done' : '' }> <i class="fas fa-circle"></i> Minimum of one numeric character</li>

                                                <li className={ this.state.specialCharacter ? 'done' : '' }> <i class="fas fa-circle"></i> Minimum of one special character</li>

                                            </ul>
                                    </div>
                                    <div className='form-group icon-input'>
                                        <i className="fas fa-unlock-alt"></i>
                                        <Inputs
                                            type="confirm_password"
                                            className="form-control"
                                            placeholder='Confirm Password'
                                            value={this.state.data.confPassword}
                                            password={this.state.data.password}
                                            required={ true }
                                            onChange={ (value, valid) => this.onDataChange('confPassword', value, valid)}
                                            errorMessage={'5555'} />
                                    </div>
                                    <button
                                        type="button"
                                        onClick={this.registerUser}
                                        disabled={!this.state.formValid || !passwordConfirm}
                                        className="btn login-button">
                                        Sign Up
                                        {this.props.createdUserFetching && <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>}
                                    </button>
                                </form>

                                <p className="forgot-password"><Link to="/login">Sign In</Link></p>
                            </div>
                        }
                        { this.props.createdUserFetching &&
                            <div className="card-body">
                                {this.elementInfiniteLoad()}
                            </div>
                        }
                        { this.props.createdUserData.statusCode === 200 &&
                            <div className="success-data">
                                <p className='success-data-p' >{this.props.createdUserData.message}</p>
                                <p className="forgot-password"><i class="fas fa-long-arrow-alt-left"></i><Link to="/login">Sign In</Link></p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Registration/Registration.jsx